/// <amd-module name="TFS/NetPromoterSurvey/Components/ScoreChoiceGroup" />
import { IResponse } from "Common";
import { Label } from "OfficeFabric/Label";
import * as React from "react";
import * as NetPromoterSurveyResources from "TFS/NetPromoterSurvey/Resources";

export interface ScoreChoiceGroupProps {
    selected?: number;
    scoreCount: number;
    label: string;
    labelMinimum: string;
    labelMaximum: string;
    onChange(response: Partial<IResponse>): void;
    onClick?(): void;
}

export const ScoreChoiceGroup: React.SFC<ScoreChoiceGroupProps> = props => {
    const choices: JSX.Element[] = [];
    for (let i = 0; i <= props.scoreCount; i++) {
        const selected = props.selected === i;
        const id = "nps-score-choice" + i.toString();
        choices.push(
            <li key={i.toString()} className="nps-score-choice">
                <input
                    type="radio"
                    id={id}
                    name={id}
                    checked={selected}
                    onChange={() => props.onChange({ score: i })}
                    onClick={() => {
                        !!props.onClick && props.onClick();
                    }}
                />
                <label className={"fontSizeM fontWeightSemiBold" + (selected ? " selected" : "")} htmlFor={id}>
                    {i}
                </label>
            </li>
        );
    }

    return (
        <div className="nps-score">
            <Label className="fontSizeM fontWeightSemiBold nps-score-label">{props.label}</Label>
            <ul>{choices}</ul>
            <div className="fontSizeS fontWeightSemiBold flex-row">
                <span className="flex-grow">{NetPromoterSurveyResources.Score0Label}</span>
                <span>{NetPromoterSurveyResources.Score10Label}</span>
            </div>
        </div>
    );
};
